import {nil} from "felles-ng2/typer/nullish";

/** Sann dersom verdi ikke er null eller undefined.
 * <pre>
 * PS: `verdi is T` uttrykket er en 'type narrowing' som gjør at typen blir snevret inn fra T|null til T ved bruk i
 * kombinasjon med feks if(..), eks:
 * const strengEllerNull :string|null = '..';
 * if (erIkkeNil(strengEllerNull)) strengEllerNull.toLocaleLowerCase()
 * </pre>
 */
export function erIkkeNil<T>(verdi: T | nil): verdi is T {
    return !erNil(verdi);
}

export function erNil<T>(verdi: T | nil): verdi is nil {
    return verdi === null || verdi === undefined;
}

/** denne kan som regel omgås ved å skrive `<uttrykk> ?? <standard verdi>`, men vær oppmerksom dersom T er number */
export function standard<T>(verdi: T | nil, dersomNull: T): T {
    return erNil(verdi) ? dersomNull : verdi!;
}

/** Returnerer resultatet av angitt dersomIkkeNil-metode dersom verdi er ikke nil, eller returneres angitt dersomNil-verdi */
export function dersomIkkeNil<T, R>(verdi: T | nil, dersomIkkeNil: (ikkeNil: T) => R, dersomNil: R): R {
    return erNil(verdi) ? dersomNil : dersomIkkeNil(verdi);
}

/** Kaller 'dersomIkkeNil' med angitt verdi dersom denne er ikke-nil */
export function gjørDersomIkkeNil<T, R>(verdi: T | nil, dersomIkkeNil: (ikkeNil: T) => void): void {
    if (erIkkeNil(verdi)) dersomIkkeNil(verdi);
}
